<template>
  <widget-temp widgetTitle="Báo cáo mã hàng theo trạng thái" widgetName="OrderStatusChart" v-bind:widgetId="4">
    <template slot="widget-content">
      <div class="chart-container">
        <highcharts :options="chartOptions"></highcharts>
      </div>
    </template>
  </widget-temp>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "order-status-chart",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      loading: state => state.dashboard.loading,
      orderData: state => state.dashboard.order_status_chart
    }),
    chartOptions() {
      return {
        chart: {
          type: 'column',
          height: 400
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.orderData.map(item => item.name),
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Số lượng mã hàng'
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="padding:0"><b>{point.y}</b> mã hàng</td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y}'
            }
          }
        },
        series: [{
          name: 'Số lượng',
          colorByPoint: true,
          data: this.orderData.map(item => ({
            y: item.value,
            color: item.color
          }))
        }],
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        }
      };
    }
  },
  methods: {
    async getChartData() {
      this.$store.dispatch("dashboard/getOrderStatusChart");
    }
  },
  mounted() {
    this.getChartData();
  }
};
</script>

<style scoped>
.chart-container {
  padding: 20px;
  min-height: 400px;
}
</style>
